// Storage utility with 1-hour expiration
interface StorageItem {
  value: any;
  expiry: number;
}

const EXPIRY_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

export const storage = {
  // LocalStorage with expiration
  setLocal: (key: string, value: any) => {
    const item: StorageItem = {
      value,
      expiry: Date.now() + EXPIRY_TIME
    };
    localStorage.setItem(key, JSON.stringify(item));
  },

  getLocal: (key: string) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item: StorageItem = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  },

  // SessionStorage with expiration
  setSession: (key: string, value: any) => {
    const item: StorageItem = {
      value,
      expiry: Date.now() + EXPIRY_TIME
    };
    sessionStorage.setItem(key, JSON.stringify(item));
  },

  getSession: (key: string) => {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) return null;

    const item: StorageItem = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value;
  },

  // Cookie with expiration
  setCookie: (name: string, value: string) => {
    const expires = new Date(Date.now() + EXPIRY_TIME).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  },

  getCookie: (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return null;
  },

  // Clear all expired items
  clearExpired: () => {
    // Clear expired localStorage items
    Object.keys(localStorage).forEach(key => {
      storage.getLocal(key); // This will auto-remove if expired
    });

    // Clear expired sessionStorage items
    Object.keys(sessionStorage).forEach(key => {
      storage.getSession(key); // This will auto-remove if expired
    });
  }
};